import React from "react";

const freeServicesItems = [
  {
    image: "/assets/phone-security.webp",
    altText: "Phone Security",
    icon: "/assets/shield.svg",
    iconAltText: "Shield",
    title: "FREE Security Protection",
    description:
      "Every VLE Mobile plan includes Basic or Complete security protection powered by Aura.com at no extra cost.",
    items: [
      "Dark web monitoring and fraud alerts",
      "Identity theft protection for the whole family",
      "Online safety for children",
      "Up to $5M identity theft insurance",
    ],
  },
  {
    image: "/assets/global-communication.webp",
    altText: "Global Communication",
    icon: "/assets/globe.svg",
    iconAltText: "Globe",
    title: "FREE Global Communication",
    description:
      "Stay connected anywhere your work takes you with included international features.",
    items: [
      "Free calls to 170+ countries",
      "Free roaming in 80+ countries",
      "Free WiFi calling and texting worldwide",
      "Perfect for drivers who serve international travelers",
    ],
  },
  {
    image: "/assets/triple-network-access.webp",
    altText: "Triple Network Access",
    icon: "/assets/triple-network.svg",
    iconAltText: "Triple Network",
    title: "FREE Triple Network Access",
    description:
      "Never worry about coverage gaps or signal loss during your driving shifts.",
    items: [
      "Automatic switching between all 3 major US networks",
      "A triple 5G service means virtually no dead zones",
      "Better coverage than any single carrier",
      "More reliable GPS navigation and app connectivity",
    ],
  },
  {
    image: "/assets/data-rollover.webp",
    altText: "Data Rollover",
    // document-management-system-dms-businessman-hold-folder-document-icon-software-archiving
    icon: "/assets/rollover.svg",
    iconAltText: "Data Rollover",
    title: "FREE Data Rollover† - Exclusive!",
    description:
      "Your unused data never expires - perfect for varying work schedules.",
    items: [
      "Unlimited data carryover on most plans",
      "Stack up your data during slow periods",
      "Use accumulated data during busy seasons",
      "Never lose what you've paid for",
    ],
    plan: "†Excludes single network and unlimited plans",
  },
];

export const FreeServices = () => {
  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
      <div className="text-center mb-14 sm:mb-[4.25rem] md:mb-20 lg:mb-[5.625rem]">
        <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
          FREE Services Included With Every Plan
        </h2>
        <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base md:text-lg font-normal leading-5 sm:leading-6 md:leading-7">
          Choose the plan that fits your driving schedule and needs:
        </p>
      </div>
      <ul className="w-full max-w-[85.5rem] space-y-12 sm:space-y-14 md:space-y-16 lg:space-y-20 2xl:space-y-[6.25rem] mb-7 sm:mb-9 md:mb-11 lg:mb-[3.125rem] mx-auto">
        {freeServicesItems.map((item, index) => (
          <li
            key={index}
            className="flex flex-col gap-8 md:flex-row sm:gap-10 md:gap-12 lg:gap-14 xl:gap-16 2xl:gap-20"
          >
            <div
              className={`flex-1 flex justify-center items-center ${
                index % 2 === 0
                  ? "md:order-2 md:justify-start"
                  : "md:justify-end"
              }`}
            >
              <div className="size-[17.5rem] sm:size-[20.5rem] md:size-[23.5rem] lg:size-[26.5rem] xl:size-[29.5rem] 2xl:size-[31.25rem] shrink-0 rounded-xl md:rounded-2xl overflow-hidden">
                <img
                  src={item.image}
                  alt={item.altText}
                  className="object-cover size-full"
                />
              </div>
            </div>
            <div
              className={`flex justify-center items-center w-full max-w-[35.25rem] md:max-w-[45.25rem] mx-auto md:mx-0 ${
                index % 2 === 0
                  ? "md:order-1 md:justify-end"
                  : "md:justify-start"
              }`}
            >
              <div className="space-y-3.5 sm:space-y-4 lg:space-y-5 w-full max-w-[41.25rem]">
                <div className="relative flex items-center justify-center w-[3.75rem] h-[3.25rem] sm:w-16 sm:h-14 lg:w-[4.375rem] lg:h-[3.875rem] shrink-0">
                  <img
                    src={item.icon}
                    alt={item.iconAltText}
                    className="relative z-[1] size-11 sm:size-12 lg:size-[3.375rem]"
                  />
                  <img
                    src="/assets/group-rectangles.svg"
                    alt="Group Rectangles"
                    className="absolute inset-0 size-full"
                  />
                </div>
                <div className="">
                  <h3 className="font-mobile text-[#1D1D1B] text-[clamp(1.4375rem,calc(2.35vw+0.5rem),2.75rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem] mb-0.5 sm:mb-1">
                    {item.title.includes("†") ? (
                      <>
                        {item.title.split("†")[0]}
                        <sup className="inline-block text-xs sm:text-sm lg:text-base xl:text-lg">
                          †
                        </sup>
                        {item.title.split("†")[1]}
                      </>
                    ) : (
                      item.title
                    )}
                  </h3>
                  <p className="text-[#64748B] text-sm sm:text-[0.925rem] lg:text-base font-normal leading-5 sm:leading-[1.34375rem] lg:leading-[1.4rem]">
                    {item.description}
                  </p>
                </div>
                <ul className="space-y-3 sm:space-y-3.5 lg:space-y-4">
                  {item.items.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-2.5 sm:gap-3 lg:gap-4"
                    >
                      <img
                        src="/assets/tick-circle-orange.svg"
                        alt="Tick"
                        className="size-5 sm:size-6 md:size-7 lg:size-8 shrink-0"
                      />
                      <p className="text-[#1A0F33] text-sm sm:text-[0.925rem] lg:text-base font-medium leading-[1.125rem] sm:leading-5 lg:leading-[1.4rem]">
                        {item}
                      </p>
                    </li>
                  ))}
                </ul>
                {item.plan && (
                  <p className="text-black text-[0.6875rem] sm:text-xs lg:text-[0.8125rem] font-light leading-6 sm:leading-8 md:leading-10 lg:leading-[3.125rem]">
                    {item.plan}
                  </p>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
